var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useQuery } from "react-query";
import { createActions } from "./actions";
import React from "react";
import { useFileExplorerStore } from "./store";
export var useListFiles = function (listFiles, path) {
    return useQuery(["useListFiles", listFiles, path], function () { return __awaiter(void 0, void 0, void 0, function () {
        var files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!path) {
                        return [2 /*return*/, []];
                    }
                    return [4 /*yield*/, listFiles(path)];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, files];
            }
        });
    }); });
};
export var useFiles = function (props) {
    var api = props.api, _a = props.rootPath, rootPath = _a === void 0 ? "/" : _a;
    var list = api.list;
    // Update the path in the store when the initial path prop changes
    React.useEffect(function () {
        useFileExplorerStore.setState({ path: rootPath });
    }, [rootPath]);
    var path = useFileExplorerStore(function (state) { return state.path; });
    var selectedFiles = useFileExplorerStore(function (state) { return state.selectedFiles; });
    var renamingFileInitialName = useFileExplorerStore(function (s) { return s.renaming.initialFileName; });
    var newFolderName = useFileExplorerStore(function (s) { return s.newFolderName; });
    var _b = useListFiles(list, path), _c = _b.data, remoteFiles = _c === void 0 ? [] : _c, refetch = _b.refetch, isFetching = _b.isFetching, isLoading = _b.isLoading;
    React.useEffect(function () {
        useFileExplorerStore.setState({
            newFolderName: null,
            createFolderErrorMessage: null,
            selectedFiles: [],
        });
    }, [path]);
    // Create actions used by the UI to mutate the store
    var actions = React.useMemo(function () {
        return createActions(props, refetch);
    }, [props, refetch]);
    var files = React.useMemo(function () {
        // If a file is being renamed, mark it as in renaming state
        var files = remoteFiles.map(function (file) {
            if (file.displayName === renamingFileInitialName) {
                return __assign(__assign({}, file), { displayName: renamingFileInitialName, isRenaming: true });
            }
            return file;
        });
        // If a new folder is being created, add a draft folder to the top of the list
        if (newFolderName !== null) {
            files.unshift({
                displayName: newFolderName,
                type: "folder",
                size: {
                    low: 0,
                    high: 0,
                    unsigned: true,
                },
                lastModified: "-",
                isDraft: true,
                path: null,
                mimeType: null,
            });
        }
        return files;
    }, [remoteFiles, newFolderName, renamingFileInitialName]);
    return {
        files: files,
        refetch: refetch,
        isFetching: isFetching,
        selectedFiles: selectedFiles,
        actions: actions,
        isLoading: isLoading,
    };
};
export var useTablePreferences = function (pageSizes) {
    var preferences = useFileExplorerStore(function (s) { return s.tablePreferences; });
    React.useEffect(function () {
        if (preferences.pageSize || !pageSizes) {
            return;
        }
        useFileExplorerStore.setState(function (s) { return (__assign(__assign({}, s), { tablePreferences: __assign({ pageSize: pageSizes[0] }, s.tablePreferences) })); });
    }, [pageSizes, preferences.pageSize]);
    var setPreferences = function (tablePreferences) {
        useFileExplorerStore.setState({ tablePreferences: tablePreferences });
    };
    // Add a set preferences method
    return { preferences: preferences, setPreferences: setPreferences };
};
